import { FC } from 'react';
import { useFormik, FormikProvider, Form, FormikConfig } from 'formik';

import { i18n as I18n } from '../../../utils/i18n';

import Field from '../../fields/field';
import Textbox from '../../fields/textbox';

import { getValidator } from '../../../validators/resetPassword';

interface Values {
  email: string;
}

type OnSubmit = FormikConfig<Values>['onSubmit'];

interface Props {
  initialValues?: Values;
  onSubmit: OnSubmit;
}

const ResendConfirmationForm: FC<Props> = ({
  initialValues = { email: '' },
  onSubmit,
  ...props
}) => {
  const formik = useFormik<Values>({
    initialValues,
    onSubmit,
    validate: getValidator(),
    validateOnMount: true,
  });

  const { errors, touched, isValid } = formik;

  return (
    <FormikProvider value={formik}>
      <Form {...props}>
        <div className="field__input field__input--placeholder">
          <Field
            as={Textbox}
            type="email"
            label={I18n.t('sign_in.email.label')}
            name="email"
            placeholder={I18n.t('sign_in.email.label')}
            error={touched.email && !!errors.email}
            errorMsg={errors.email}
          />
        </div>

        <p>
          <input
            className="button button--secondary button--block"
            type="submit"
            disabled={!isValid}
            value={I18n.t('resend_confirmation.submit_button')}
          />
        </p>
      </Form>
    </FormikProvider>
  );
};

export default ResendConfirmationForm;
